module.exports = __webpack_public_path__ + "img/wz-8-4-2.b5b9f0bd.jpg";